module.exports = __webpack_public_path__ + "img/keywords.91d3b0a1.svg";